import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_21.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/worklife');
  const shareText = encodeURIComponent('Work-Life Balance Examples to Boost Employee Engagement!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Work Life Balanace — Outstanding Workplaces</title>
        <meta property="og:title" content="Work Life Balanace — Outstanding Workplaces" />
        <meta property="og:description" content="Work-Life Balance Examples to Boost Employee Engagement" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778052541/i_18_hueuhz.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/worklife" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Work Life Balanace — Outstanding Workplaces" />
        <meta name="twitter:description" content="Work-Life Balance Examples to Boost Employee Engagement" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778052541/i_18_hueuhz.jpg" />
      </Helmet>

       <div className="sight_21_page_wrapper">
        <div className="sight_21_content_container">

          <div className="sight_21_section_one">

            <h1 className="sight_21_page_title">
             Why Employee Engagement Is Declining in Indian Organizations - And What Leaders Can Do
            </h1>

            <div className="sight_21_row">

              <div className="sight_21_left">
                <div className="sight_21_image_wrapper">
                  <img src="/dec.png" alt="Team meeting discussion" className="sight_21_blog_image" />
                </div>

                {/* SHARE SECTION */}
                <div className="sight_21_share_section">
                  <span className="sight_21_share_text">Share :</span>
                  <div className="sight_21_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_21_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_21_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_21_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_21_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

           <div className="sight_21_para_wrapper">
                  <h2 className="sight_21_para_title">
                    Employee engagement has become one of the biggest challenges facing organizations today. Companies may offer competitive salaries, modern offices, employee benefits, and career opportunities, yet many employees still feel disconnected from their work and their organization.
                  </h2>
                  <h2 className="sight_21_para_title">
                    n India, where workplaces are rapidly evolving, engagement is no longer simply about employee satisfaction. Employees increasingly want meaningful work, supportive leadership, recognition, growth opportunities, flexibility, and a sense that their contribution matters.
                  </h2>
                   <h2 className="sight_21_para_title">
                    So, why is employee engagement declining in many organizations—and what can leaders do about it?
                  </h2>
                 
                  
                </div>

              </div>

              <div className="sight_21_right">
                <div className="sight_21_ad_card">
                  <img src="/assets/bc_1.png" className="sight_21_ad_bg" />
                  <div className="sight_21_ad_overlay"></div>
                  <img src="/assets/bg_1.png" className="sight_21_ad_badge" />

                  <div className="sight_21_ad_content">
                    <h2>
                      Earn the Outstanding <br />
                      <span>Workplaces Certification</span>
                    </h2>
                    <ul>
                      <li>Attract Top Talent</li>
                      <li>Boost Employee Engagement</li>
                      <li>Drive Culture-Led Growth</li>
                    </ul>
                    <button
                      className="sight_21_ad_btn"
                      onClick={() => window.location.href = '/nominate'}
                    >
                      Get Certificate
                    </button>
                  </div>
                </div>
              </div>

            </div>

            
          </div>

          <div className="sight_21_section">
            <div className="sight_21_topics">

             

              <div className="sight_21_topic_item">
                <h3 className="sight_21_topic_heading">1.⁠ ⁠Employees Want More Than a Paycheck</h3>
                <ul className="sight_21_topic_list">
                  <li>
                   Compensation remains important, but salary alone does not create long-term engagement.
Employees want to understand how their work contributes to the organization's larger purpose. When people cannot see the impact of their work, even a well-paying job can become routine.
                  </li>
                  <h3 className="sight_21_topic_heading">*What leaders can do:*</h3>
                  <li>
                    Connect individual responsibilities with organizational goals. Explain not only what employees need to achieve, but why their work matters.
                  </li>
                   
                 
                </ul>
              </div>

              <div className="sight_21_topic_item">
                <h3 className="sight_21_topic_heading">2. The Manager-Employee Relationship Matters</h3>
                <ul className="sight_21_topic_list">
                  <li>
                   Employees often do not leave companies—they leave managers.
                  </li>
                   <li>
                    A manager who communicates poorly, provides little feedback, takes credit for team achievements, or fails to recognize employee contributions can quickly reduce engagement.
                  </li>
                  <li>
                    Leadership is experienced most directly through day-to-day interactions with managers.
                  </li>
                   <h3 className="sight_21_topic_heading">*What leaders can do:*</h3>
                   <li>
                   
                   Train managers in communication, coaching, active listening, conflict management, and recognition. Leadership development should not stop at the senior-management level.
                   </li>                  
                </ul>
              </div>

              <div className="sight_21_topic_item">
                <h3 className="sight_21_topic_heading"> 3. Lack of Recognition Creates Disconnection</h3>
                <ul className="sight_21_topic_list">
                 <li className="no-bullet">
  Employees want to know that their efforts are noticed.
</li>
                  <li>
                  When hard work becomes an expectation rather than something that is appreciated, employees may gradually lose motivation. Recognition does not always need to be financial. A meaningful appreciation, public acknowledgment, or personal thank-you can have a significant impact.
                  </li>
                  <h3 className="sight_21_topic_heading">*What leaders can do:*</h3>
                  <li>
                  Build recognition into everyday workplace culture. Appreciate both major achievements and consistent contributions that help teams succeed.
                  </li>
                   
                  
                </ul>
              </div>

              <div className="sight_21_topic_item">
                <h3 className="sight_21_topic_heading">1.⁠ ⁠Limited Career Growth Drives Disengagement</h3>
                <ul className="sight_21_topic_list">
                            <li className="no-bullet">
One of the biggest questions employees ask is
</li>
<h3 className="sight_21_topic_heading">*What leaders can do:*</h3>
                  <li>
                  When employees do not see opportunities to learn new skills, take on greater responsibilities, or progress in their careers, they may start looking outside the organization.
                  </li>
                  <h3 className="sight_21_topic_heading">*What leaders can do:*</h3>
                  <li>
                 Create transparent career paths, provide mentoring opportunities, encourage internal mobility, and invest in continuous learning.
                  </li>
                  
                  
                </ul>
              </div>

              <div className="sight_21_topic_item">
                <h3 className="sight_21_topic_heading">5. Employees Want Their Voices to Be Heard</h3>
                <ul className="sight_21_topic_list">
                  <li>Organizations often conduct employee surveys, feedback sessions, and town halls. But collecting feedback is only the first step.</li>
  <li>If employees repeatedly share concerns and see no action, they may eventually stop speaking up.</li>
  <h3 className="sight_21_topic_heading">*What leaders can do:*</h3>
  <li>Create a clear feedback-to-action process. Communicate what was heard, what will change, and what may not change—and explain why.</li>
 
                  
                 
                </ul>
              </div>

              <div className="sight_21_topic_item">
                <h3 className="sight_21_topic_heading">6. Workplace Flexibility Has Changed Expectations</h3>
                <ul className="sight_21_topic_list">
                    <li>The modern workforce has different expectations about where and how work should happen.</li>
  <li>While every role cannot offer the same level of flexibility, employees increasingly value reasonable autonomy, trust, and work-life balance.</li>
  <li>Leaders who focus only on physical presence rather than outcomes can unintentionally create frustration.</li>
  <h3 className="sight_21_topic_heading">*What leaders can do:*</h3>
  <li>Where practical, focus on performance and outcomes rather than unnecessary control. Give employees clarity about expectations while allowing reasonable flexibility.</li>
  
                 
                </ul>
              </div>
               <div className="sight_21_topic_item">
                <h3 className="sight_21_topic_heading">7. Poor Communication Creates Uncertainty</h3>
                <ul className="sight_21_topic_list">
                    <li>Silence from leadership often creates its own story</li>
  <li>When organizational decisions, changes, or challenges are not communicated clearly, employees may rely on assumptions and informal conversations.</li>
  <li>Transparent communication builds trust—even when the news is difficult.</li>
  <h3 className="sight_21_topic_heading">*What leaders can do:*</h3>
  <li>Communicate regularly, clearly, and honestly. Leaders do not need to have every answer, but employees should know that leadership is willing to communicate openly.</li>
  
                 
                </ul>
              </div>
               <div className="sight_21_topic_item">
                <h3 className="sight_21_topic_heading">8. Engagement Starts With Trust</h3>
                <ul className="sight_21_topic_list">
                    <li>Trust is the foundation of an engaged workplace.</li>
  <li>Employees need to trust that leaders will treat people fairly, keep commitments, listen to concerns, and make decisions responsibly.</li>
  <li>Without trust, employee engagement initiatives can become superficial.</li>
  <h3 className="sight_21_topic_heading">*What leaders can do:*</h3>
  <li>Make leadership behavior consistent with organizational values.</li>
<li>Trust is built through repeated actions, not slogans.</li>
<li>Moving From Engagement Activities to Engagement Culture</li>
<li>Employee engagement should not be treated as an annual HR initiative.</li>
<li>A company picnic, employee survey, rewards program, or team event can contribute to engagement—but these activities cannot compensate for poor leadership, limited growth, weak communication, or a lack of recognition.</li>
<li>True engagement is created through the everyday employee experience.</li>
  
                 
                </ul>
              </div>
              <div className="sight_21_topic_item">
                <h3 className="sight_21_topic_heading">## The Future of Employee Engagement</h3>
                <ul className="sight_21_topic_list">
     <li>The future of employee engagement in India will be shaped by organizations that understand one simple principle:</li>
     <h3 className="sight_21_topic_heading">*People do not become engaged because an organization tells them to. They become engaged when the workplace gives them reasons to care.*</h3>
  <li>When employees feel trusted, valued, heard, supported, and connected to a meaningful purpose, engagement becomes more than a measurement on an HR dashboard. It becomes part of the organization's culture—and ultimately, part of its competitive advantage.</li>
  <li>Employee engagement is not an HR responsibility alone. It is a leadership responsibility.</li>
<li>Organizations that want higher engagement must look beyond engagement scores and examine the everyday experiences that create those scores.</li>
<h3 className="sight_21_topic_heading">*Listen to employees. Develop leaders. Recognize contributions. Build trust. Create opportunities.*</h3>
<li>That is how organizations move from simply having employees to building a workforce that is genuinely committed to the organization's success.</li>
 
                 
                </ul>
              </div>

             

              

            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default BlogPage;